{"version":"0.5.0","sha":"b6969ab","branch":"develop","env":"dev","builtAt":"2026-06-15T19:16:56.823Z"}